module.exports = __webpack_public_path__ + "static/media/tooltip-selected.f22adc86.svg";